import { createSelector } from 'reselect';

const getProjects = (state) => state.user.enabledProjects;

export default createSelector(getProjects, (projects) =>
  projects.map((project) => project.projectId)
);
